'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// (i)-Icon  which opens tooltip when hovering. Uses UI Bootstrap Popover.
_module3.default.directive('tooltip', ['$filter', '$templateCache', function ($filter, $templateCache) {
    return {
        restrict: 'E',
        transclude: true,
        template: '<i uib-popover-template="templateUrl" class="fa fa-info-circle" popover-trigger="mouseenter"></i>',
        compile: function compile(elem, attrs) {
            return function (scope, element, attrs, controller, transclude) {
                transclude(scope, function (clone) {
                    // Automatically translate if a simple element (Angular
                    // wraps text in span when transcluding)
                    if (clone.length == 1 && clone[0].tagName == 'SPAN' && clone.children().length == 0) {
                        clone.attr('ng-i18next', '');
                    }

                    // Get OuterHTML by trickery
                    var outerHTML = _angular2.default.element('<p></p>').html(clone).html();

                    // Wrap in DIV, since uib-popover requires template to 
                    // be wrapped in a single element. 
                    var template = '<div>' + outerHTML + '</div>';

                    // UIB tooltip supports only templates from URL, not from
                    // transclusion or attribute. (except for uncompiled ones).
                    //
                    // Fake the URL by storing the "URL" into the template 
                    // cache and then passing it.
                    scope.templateUrl = 'tooltip-dynamic-template-' + scope.$id;
                    $templateCache.put(scope.templateUrl, template);
                });
            };
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./src/core/tooltip.js
// module id = 52
// module chunks = 0 2